import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAQz8zVg8VaXwPqKxQKObE3f1BJRb_cygs",
  authDomain: "bhfj-6b678.firebaseapp.com",
  projectId: "bhfj-6b678",
  storageBucket: "bhfj-6b678.firebasestorage.app",
  messagingSenderId: "778703579743",
  appId: "1:778703579743:web:ea15ed07e33a0b4b6049ea",
  measurementId: "G-YVC55P72YR"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;